import { render } from "./HelpVideoModal.vue?vue&type=template&id=0a6b843d&scoped=true"
import script from "./HelpVideoModal.vue?vue&type=script&lang=js"
export * from "./HelpVideoModal.vue?vue&type=script&lang=js"

import "./HelpVideoModal.vue?vue&type=style&index=0&id=0a6b843d&scoped=true&lang=css"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a6b843d"]])

export default __exports__